import mixpanel from "mixpanel-browser";
mixpanel.init(`${process.env.REACT_APP_TOKEN_MIXPANEL}`);

let actions = {
  identify: id => {
    mixpanel.identify(id);
  },
  alias: id => {
    mixpanel.alias(id);
  },
  track: (name, props) => {
    mixpanel.track(name, props);
  },
  track_forms: (name, props) => {
    mixpanel.track_forms(name, props);
  },
  track_links: (name, props) => {
    mixpanel.track_links(name, props);
  },
  track_links_obj: obj => {
    for (let key in obj) {
      mixpanel.track_links(key, obj[key]);
    }
  },
  people: {
    set: props => {
      mixpanel.people.set(props);
    }
  }
};

export let Mixpanel = actions;



// WEBPACK FOOTER //
// ./src/actions/mixpanel.actions.js